import { render, staticRenderFns } from "./OutlineEdit.vue?vue&type=template&id=2968f8b8&"
import script from "./OutlineEdit.vue?vue&type=script&lang=js&"
export * from "./OutlineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports